import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {Organization} from '../types';

export const columns = [
    {
        title: I18n.get('Name'),
        width: '1fr',
        render: (item: Organization) => <NavLink to={`/organizations/${item.id}`}>{item.name}</NavLink>,
    },
    {
        title: I18n.get('Admin Account'),
        width: '1fr',
        render: (item: Organization) => item.adminAccountId,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Organization) => formatTimestamp(item.created),
    },
];
